import clsx from 'clsx';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { IoMdSearch } from 'react-icons/io';
import DrawerSkeleton from '../..';
import { PersonIcon } from '../../../Assets/icons';
import NoDataFound from '../../../Components/General/NoDataFound';
import PatientShortDetailCard from '../../../Components/General/PatientsShortDetailCard';
import Button from '../../../Components/UI/Button';
import { Input } from '../../../Components/UI/Input';
import MiniLoader from '../../../Components/UI/MiniLoader';
import useDebounce from '../../../CustomHooks/useDebounce';
import usePatient from '../../../Features/usePatient';
import CreatePatientAndAppointmentDrawer from '../../CreatePatientAndAppointment';
import DrawerHeader from '../../DrawerHeader';
import CreateAppointmentDetailDrawer from '../CreateAppointmentDetailDrawer';
import PatientInformationDrawer from '../PatientInformation';
import classes from './ScheduleListDrawer.module.css';
import { parseBooleanFromString } from '../../../Helpers';
export default function ScheduleListDrawer({ show, setShow, selectedDate, date, data = [] }) {
  const [showPatientInformationDrawer, setShowPatientInformationDrawer] = useState(false);
  const [searchByName, setSearchByName] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const searchDebounce = useDebounce(searchByName, 600);
  const [showCreatePatientDrawer, setShowCreatePatientDrawer] = useState(false);
  const [showCreateAppointmentDetail, setShowCreateAppointmentDetail] = useState(false);
  const { getAllExistingPatients, existingPatients, setExistingPatients, loading } = usePatient();
  const togglePatientInfoDrawer = () => {
    setShowPatientInformationDrawer((prev) => !prev);
  };
  const toggleCreatePatientDrawer = () => {
    setShowCreatePatientDrawer((current) => !current);
  };
  const toggleCreateAppointmentDetail = () => {
    setShowCreateAppointmentDetail((current) => !current);
  };
  useEffect(() => {
    if (searchDebounce)
      getAllExistingPatients({
        patientName: searchDebounce,
        patientCellNo: '',
        patientEMRNo: ''
      });
  }, [searchDebounce]);
  //first show schedule appointments I f users search anything show listing of patients
  let content = (
    <>
      <h3 className={classes.mainHeading}>Scheduled Appointments</h3>
      {data?.length > 0 ? (
        data?.map((data) => (
          <PatientShortDetailCard
            name={data?.patient?.patientName}
            age={data?.patient?.age}
            gender={data?.patient?.gender}
            appointmentTime={data?.appointmentStartDateTime}
            cellNumber={data?.patient?.cellCountryCode + data?.patient?.cellNumber}
            isAppointment={data?.isAppointment}
            isDeleted={data?.isDeleted}
            isFollowupPatient={!data?.isAppointment && !data?.isDeleted}
            schedule={true}
            className={classes.card}
            onClick={() => {
              setSelectedItem(data);
              togglePatientInfoDrawer();
              setShow();
            }}
          />
        ))
      ) : (
        <NoDataFound className={classes.noDataFound} label="No Appointments Found" />
      )}
    </>
  );
  if (searchDebounce) {
    content = (
      <>
        <h3 className={classes.mainHeading}>Patients List</h3>
        {existingPatients?.length > 0 ? (
          existingPatients?.map((data) => (
            <PatientShortDetailCard
              amount={data?.patientNetAmount}
              cellNumber={data?.cellNumber}
              name={data?.name}
              gender={data?.gender}
              age={data?.age}
              isWalkInPatient={parseBooleanFromString(data?.isWalkInPatient)}
              isAppointment={parseBooleanFromString(data?.isAppointmentPatient)}
              isFollowupPatient={parseBooleanFromString(data?.isFollowupPatient)}
              className={classes.card}
              onClick={() => {
                setSelectedItem(data);
                toggleCreateAppointmentDetail();
                setShow();
              }}
            />
          ))
        ) : (
          <NoDataFound className={classes.noDataFound} label="No Appointments Found" />
        )}
      </>
    );
  }

  return (
    <>
      <DrawerSkeleton
        show={show}
        setShow={() => {
          setSearchByName('');
          setExistingPatients([]);
          setShow();
        }}>
        <div className={clsx(classes.wrapper)}>
          <div className={classes.content}>
            <DrawerHeader
              prev={false}
              title={'Schedule'}
              setShow={() => {
                setSearchByName('');
                setExistingPatients([]);
                setShow();
              }}
            />
            <section className={clsx(classes.listWrapper, 'scrollbar1')}>
              <div className={classes.dateSection}>
                <h3>
                  {date ? date : moment(data?.appointmentStartDateTime).format('DD MMMM YYYY')}
                </h3>
              </div>
              <div className={classes.actionWrapper}>
                <Input
                  className={classes.searchBox}
                  placeholder="Search Name or Phone"
                  value={searchByName}
                  setter={setSearchByName}
                  rightIcon={
                    <span className={classes.inputRightIcon}>
                      <IoMdSearch size={22} color="var(--icon-color)" />
                    </span>
                  }
                />
                <Button
                  leftIcon={<PersonIcon color="var(--primary-color)" />}
                  variants="view"
                  label="Add New Patient"
                  className={classes.calendarButton}
                  onClick={() => {
                    setExistingPatients([]);
                    toggleCreatePatientDrawer();
                    setShow();
                  }}
                />
              </div>
              {loading ? <MiniLoader /> : content}
            </section>
            <div className={classes['cta-wrapper']}>
              <Button
                variants="secondary"
                label={'Close'}
                onClick={() => {
                  setSearchByName('');
                  setShow();
                }}
              />
            </div>
          </div>
        </div>
      </DrawerSkeleton>
      <CreatePatientAndAppointmentDrawer
        show={showCreatePatientDrawer}
        setShow={toggleCreatePatientDrawer}
        setShow2={() => {
          setShow();
        }}
      />
      <CreateAppointmentDetailDrawer
        data={{
          ...selectedItem,
          patientName: selectedItem?.name,
          countryCode: selectedItem?.cellNumber?.slice(0, 3),
          cellNumber: selectedItem?.cellNumber?.slice(3)
        }}
        show={showCreateAppointmentDetail}
        setShow={() => {
          setSearchByName('');
          setExistingPatients([]);
          toggleCreateAppointmentDetail();
        }}
        setShow2={setShow}
      />
      <PatientInformationDrawer
        show={showPatientInformationDrawer}
        setShow={togglePatientInfoDrawer}
        selectedDate={selectedDate}
        data={{
          ...selectedItem,
          cellNumber: selectedItem?.patient?.cellNumber,
          patientId: selectedItem?.patient?.patientId,
          patientName: selectedItem?.patient?.patientName
        }}
        setShow2={setShow}
      />
    </>
  );
}
